(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("geotiff-channel-mapping", [], factory);
	else if(typeof exports === 'object')
		exports["geotiff-channel-mapping"] = factory();
	else
		root["geotiff-channel-mapping"] = factory();
})(self, function() {
return 